import { useTranslation } from "react-i18next"
import { Check } from "@phosphor-icons/react"
import { Chip } from "@/components/ui/chip"
import { cn } from "@/lib/utils"
import {
  useAllProgressNotesFilters,
  useEpisodeOfCareStoreContext,
} from "@/modules/patients/detail/store/useEpisodeOfCareStore"

type MyNotesFilterProps = React.ComponentPropsWithoutRef<typeof Chip>

const MyNotesFilter = ({ className, ...props }: MyNotesFilterProps) => {
  const { t } = useTranslation()
  const { filters } = useAllProgressNotesFilters()
  const setFilters = useEpisodeOfCareStoreContext((state) => state.setAllProgressNotesFilters)
  const myNotes = !!filters.onlyMyNotes

  const handleChange = () => {
    setFilters({ onlyMyNotes: !myNotes })
  }

  return (
    <Chip {...props} checked={myNotes} className={cn("h-8", className)} onClick={handleChange}>
      <div className="flex items-center gap-0.5">
        <Check className={`w-${myNotes ? "5" : "0"} overflow-hidden transition-all duration-200`} size={20} />
        <div className="truncate px-1.5">{t("episodeOfCare.filters.myNotes")}</div>
      </div>
    </Chip>
  )
}

MyNotesFilter.displayName = "MyNotesFilter"

export { MyNotesFilter }
